export const EASY = 'easy'
export const MEDIUM = 'medium'
export const HARD = 'hard'

export const gameModes = [EASY, MEDIUM, HARD]
